import React from 'react';
import { Link } from 'react-router-dom';
import useStytchQueryString from '../../../../hooks/useStytchQueryString';

const Failure = () => {
    const stytchQueryString = useStytchQueryString();

    return (
        <>
            <p className="text-center mb-3 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                The link you clicked is no longer valid. Please{' '}
                <Link to={`/login${stytchQueryString}`} className="display8 accent">
                    return to the login page
                </Link>{' '}
                and request a new link.
            </p>

            <p className="text-center mb-3 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                Still need help?
            </p>

            <p className="text-center mb-4 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                <a className="accent" href="mailto:membership@icsc.com">
                    Contact us.
                </a>
            </p>
        </>
    );
};

Failure.propTypes = {};

export default Failure;
